import { useRecordContext, type InputProps } from "ra-core";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { useIsMobile } from "@/hooks/use-mobile";

import type { Contact } from "../types";
import { contactFullName } from "./contactModel";

const MAX_CONTACT_CHOICES = 25;

/**
 * Almikia Epic EC2a: a search picker of another contact (the referring contact, the origin
 * colega, the tenant an Aval guarantees). Searches the server (`q`), never lists the whole
 * address book, and leaves the contact being edited out of its own choices.
 */
export const ContactLinkInput = ({
  source,
  label,
  validate,
  filter,
}: Pick<InputProps, "validate"> & {
  source: string;
  label: string;
  /** Extra filter on the choices, for example `{ "contact_types@cs": "{colega}" }`. */
  filter?: Record<string, unknown>;
}) => {
  const record = useRecordContext<Contact>();
  const isMobile = useIsMobile();
  const selfFilter = record?.id != null ? { "id@neq": record.id } : {};
  return (
    <ReferenceInput
      source={source}
      reference="contacts"
      perPage={MAX_CONTACT_CHOICES}
      filter={{ ...selfFilter, ...filter }}
    >
      <AutocompleteInput
        label={label}
        optionText={(contact: Contact) => contactFullName(contact)}
        helperText={false}
        validate={validate}
        modal={isMobile}
      />
    </ReferenceInput>
  );
};
